import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { CardGroup, Container } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { AddIcon } from "../../../../data/iconImage";
import { formatSplitKey } from "../../../../commons/FormatValue";
import { ExcelFileHandler } from "../../../../components/ExcelFileHandler";
import {
  deleteServiceRequest,
  getServiceRequest
} from "../../../../commons/ServiceRequest";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import ItemStepDesService from "../../../../services/itemstepdes.service";
import ItemStepMastersService from "../../../../services/itemstepmas.service";

export default function OperatingProcedures() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [itemStepMas, setItemStepMas] = useState([]);
  const [data, setData] = useState([]);
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "ขั้นตอนการปฏิบัติงาน",
      selector: (row) => row.Item_Step_Des,
      sortable: true,
      grow: 2
    },
    {
      name: "Priority",
      selector: (row) => row.Item_Step_Priority,
      center: true
    },
    {
      name: "เงื่อนไขการข้าม1",
      selector: (row) => (row.Item_Step_Require1 ? "Y" : "N"),
      center: true
    },
    {
      name: "เงื่อนไขการข้าม2",
      selector: (row) => (row.Item_Step_Require2 ? "Y" : "N"),
      center: true
    },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          editButton
          deleteButton
          onDeleteCallback={handleSubmitDelete}
        />
      ),
      width: "180px",
      right: true
    }
  ];
  const searchInput = [
    { name: "Item.Item_Code", label: "รหัสสินค้า" },
    { name: "Item.Item_Name_TH", label: "ชื่อสินค้า" }
  ];

  const filteredDataToExcel = () => {
    const allHaveSameName = searchValue?.every(
      ({ name }) => name === searchValue[0].name
    );

    const filteredItems = data?.filter((item) =>
      !allHaveSameName
        ? searchValue?.every(({ name, value }) =>
            value ? formatSplitKey(name, ".", item) === value : item
          )
        : searchValue?.some(({ name, value }) => value === item[name])
    );

    return filteredItems || [];
  };

  const handleSubmitDelete = (event, { Id }) => {
    event.preventDefault();

    if (Id) {
      deleteServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: ItemStepDesService.deleteItemStepDescriptions(
          Id,
          false
        ),
        refreshRequest: ItemStepDesService.getAllItemStepDescriptions(),
        callback: (res) => setData(res)
      });
    }
  };

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ItemStepMastersService.getAllItemStepMasters(),
      callback: (res) => setItemStepMas(res)
    });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ItemStepDesService.getAllItemStepDescriptions(),
      callback: (res) => setData(res)
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>ขั้นตอนการปฏิบัติงาน</title>
        <meta name="description" content="Operating Procedures Page" />
      </Helmet>

      <Container fluid className="p-3">
        <CardDisplayComponent
          body={{
            element: (
              <SearchFilter
                data={itemStepMas}
                inputField={searchInput}
                fieldClassName={{ actionButton: "w-auto py-2" }}
                searchCallback={(search) => {
                  const updated = itemStepMas
                    .filter((item) =>
                      search.every(({ name, value }) =>
                        value
                          ? name
                              .split(".")
                              .reduce((obj, prop) => obj[prop], item) === value
                          : item
                      )
                    )
                    .map(({ Id }) => ({ name: "Item_Step_Id", value: Id }));

                  setSearchValue(
                    search.some(({ value }) => value) ? updated : []
                  );
                }}
              />
            )
          }}
        />

        <CardDisplayComponent
          header={{
            title: { text: "ขั้นตอนการปฏิบัติงาน" },
            className: "d-flex justify-content-between align-items-center",
            button: (
              <CardGroup className="d-flex">
                <ButtonLink
                  linkTo="create"
                  buttonName="เพิ่มข้อมูล"
                  buttonClass="py-2 px-3 rounded-pill"
                  iconSrc={AddIcon}
                  iconClass="me-2 mb-1"
                  iconName="Add Icon"
                />

                <ExcelFileHandler
                  data={filteredDataToExcel()}
                  columns={columns.map((col) => col.name)}
                />
              </CardGroup>
            )
          }}
          body={{
            element: (
              <Table
                data={data}
                column={columns}
                pending={loading}
                searchFilter={searchValue}
                pagination
              />
            )
          }}
        />
      </Container>
    </>
  );
}
